export default "__VITE_ASSET__B3e92Rbk__"